var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInserBelow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C6.75329 1.5 2.5 5.75329 2.5 11C2.5 16.2467 6.75329 20.5 12 20.5C17.2467 20.5 21.5 16.2467 21.5 11C21.5 5.75329 17.2467 1.5 12 1.5ZM1 11C1 4.92487 5.92487 0 12 0C18.0751 0 23 4.92487 23 11C23 17.0751 18.0751 22 12 22C5.92487 22 1 17.0751 1 11Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 23.25C2 22.8358 2.33579 22.5 2.75 22.5H21.25C21.6642 22.5 22 22.8358 22 23.25C22 23.6642 21.6642 24 21.25 24H2.75C2.33579 24 2 23.6642 2 23.25Z",
    fill: "#111111"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_12238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8998 6.2998C12.1569 6.2998 12.3654 6.50822 12.3654 6.76532V10.3343H15.9344C16.1915 10.3343 16.3999 10.5427 16.3999 10.7998C16.3999 11.0569 16.1915 11.2653 15.9344 11.2653H12.3654V14.8343C12.3654 15.0914 12.1569 15.2998 11.8998 15.2998C11.6427 15.2998 11.4343 15.0914 11.4343 14.8343V11.2653H7.86542C7.60832 11.2653 7.3999 11.0569 7.3999 10.7998C7.3999 10.5427 7.60832 10.3343 7.86542 10.3343H11.4343V6.76532C11.4343 6.50822 11.6427 6.2998 11.8998 6.2998Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_12238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(7.3999 6.2998)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInserBelow);
export default __webpack_public_path__ + "static/media/inser-below.42a99e87.svg";
export { ForwardRef as ReactComponent };